function baseTabState() {
  return {
    pagination: {
      itemsPerPage: 10,
      itemsPerPageArray: [10, 20, 50, 100],
      page: 1,
    },
    totalItems: 0,
    searchBy: "life_insured_name",
    searchValue: "",
    showBy: {},
    dateRange: null,
    claimStatus: {},
    selectedBanks: [],
  };
}

function state() {
  return {
    tabData: {
      register: baseTabState(),
      dibatalkan: baseTabState(),
      disetujui: baseTabState(),
    },
  };
}

export default state;
